// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: App settings & contact channels  (the storefront pause notice)
// Shows staff's headline (and expected resumption) while the storefront is paused from Admin → App settings. The backend is what actually refuses new orders and payments
// (503 STOREFRONT_PAUSED); this only tells the customer why. Renders nothing when the storefront is open or the settings can't be read. `role="status"` so it is announced.
// Neighbours: hooks/useContactInfo (useAppSettings), pages/Menu, pages/Checkout, utils/appSettings.
// ─────────────────────────────────────────────────────────────────────────────
import { OctagonAlert } from "lucide-react";
import { useAppSettings } from "../hooks/useContactInfo";

export default function StorefrontNotice({ className = "" }: { className?: string }) {
  const s = useAppSettings();
  if (!s?.maintenance.enabled) return null;
  return (
    <div role="status" data-testid="storefront-notice" className={`flex items-start gap-3 rounded-2xl bg-coral-500/10 p-4 text-sm text-coral-700 dark:text-coral-300 ${className}`}>
      <OctagonAlert className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" />
      <div>
        <p className="font-bold">{s.maintenance.headline}</p>
        {s.maintenance.resumption && <p className="mt-0.5">Expected back: {s.maintenance.resumption}</p>}
        <p className="mt-0.5">New orders are paused for now. Orders already placed are not affected.</p>
      </div>
    </div>
  );
}
